import { apiClient } from './client';
import { WebhookCaptureResponse } from '../types';

export const getCaptures = (token: string) =>
  apiClient.get<WebhookCaptureResponse[]>(`/api/inspector/${token}`).then(r => r.data);

export const deleteCaptures = (token: string) =>
  apiClient.delete(`/api/inspector/${token}`).then(() => {});
